export type PeriodMode = "annual" | "monthly";

export function scale(n: number | undefined | null, mode: PeriodMode) {
  const v = Number(n ?? 0);
  return mode === "monthly" ? v / 12 : v;
}

export function fmtEUR(v: number, mode: PeriodMode) {
  return scale(v, mode).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
}

export function suffix(mode: PeriodMode) {
  return mode === "monthly" ? " / mes" : " / año";
}
